
import {
  Component,
  Input,
  OnInit,
  Type,
  ViewChild
} from '@angular/core';

import { ExpandedComponentDirective } from '../../../directives/expanded-component.directive';

interface ExpandedComponent {
  value: any;
}

@Component({
  selector: 'app-expanded-row',
  templateUrl: './expanded-row.component.html',
  styleUrls: ['./expanded-row.component.scss'],
  standalone: true,
  imports: [
    ExpandedComponentDirective
  ]
})
export class ExpandedRowComponent implements OnInit {

  @Input() element: any;

  @Input() expandedComponent?: Type<any>;
  @ViewChild(ExpandedComponentDirective, { static: true })
  dynamicComponent!: ExpandedComponentDirective;

  ngOnInit(): void {
    this.loadComponent();
  }

  loadComponent(): void {
    if (!this.expandedComponent) {
      console.error('Component not provided');
      return;
    }

    const viewContainerRef = this.dynamicComponent.viewContainerRef;

    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(
      this.expandedComponent
    );

    componentRef.setInput('value', this.element);
  }
}
